module.exports = __webpack_public_path__ + "img/login_bg_new.937ed489.png";